import styled from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import { WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  position: relative;
  padding: 40px 0 30px;

  &::before {
    content: '';
    display: block;
    width: 100vw;
    height: 100%;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    position: absolute;
    background-color: inherit;
  }

  .content {
    text-align: center;
    ${breakpoints.up('md')} {
      text-align: left;
    }

    &__title {
      padding-bottom: 16px;
      position: relative;
      z-index: 2;

      ${breakpoints.up('md')} {
        border-bottom: 1px solid ${rgba(WHITE, 0.3)};
      }
    }

    &__box {
      align-items: flex-start;
      align-content: flex-start;
      flex-direction: column-reverse;
      position: relative;
      padding-top: 10px;

      ${breakpoints.up('md')} {
        flex-direction: row;
        position: static;
        padding-top: 30px;
      }
    }

    &__carousel {
      width: 100%;
      ${breakpoints.up('md')} {
        width: 50%;
      }
    }
  }

  .content-info {
    width: 100%;
    position: relative;

    ${breakpoints.up('md')} {
      width: 50%;
      padding: 0 20px 50px 0;
    }

    &__title {
      padding: 10px 0;

      ${breakpoints.up('md')} {
        padding: 0 0 16px;
      }
    }

    &__genres {
      font-size: 1.4rem;
    }

    &__description {
      text-align: left;
      padding: 10px 0;
      margin: 10px 0;
      border-top: 1px solid ${rgba(WHITE, 0.3)};

      ${breakpoints.up('md')} {
        padding: 20px 0;
        margin: 0;
        border: none;
      }
    }

    &__btn {
      max-width: 300px;
    }
  }

  .swiper-container {
    width: 100%;
    z-index: 3;
    padding-bottom: 10px;
    counter-reset: section;

    ${breakpoints.up('md')} {
      width: 50vw;
    }

    .swiper-wrapper {
      ${breakpoints.up('md')} {
        padding-left: 10px;
      }
    }

    .swiper-slide {
      transform: scale(0.8);
      opacity: 0.33;
      transition-duration: 300ms;
      width: 164px;
      padding: 0 10px 0;
      counter-increment: section;

      &.no-transition {
        transition: none;
      }

      &.swiper-slide-active {
        opacity: 1;
        transform: scale(1);
        z-index: 2;
      }

      ${breakpoints.up('md')} {
        width: auto;
      }
    }
  }

  .slide-image-holder {
    width: 144px;
    position: relative;
    margin: 0 auto;

    &::after {
      content: '';
      display: block;
      width: 100%;
      padding-bottom: 150%;
    }

    ${breakpoints.up('md')} {
      width: 255px;
    }
  }

  .slide-image {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    border-radius: 9px;
  }

  .swiper-navigation {
    position: absolute;
    z-index: 10;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    width: 222px;
    justify-content: space-between;

    ${breakpoints.up('md')} {
      bottom: 20px;
      top: auto;
      left: 0;
      transform: none;
      width: auto;
    }
  }

  .swiper-button-nav {
    position: static;
    color: #fff;
    opacity: 0.5;
    width: 46px;
    height: 46px;

    &::after {
      content: none;
    }

    &:hover {
      opacity: 0.8;
    }

    .MuiSvgIcon-root {
      width: 100%;
      height: 100%;
    }
  }

  .swiper-pagination-bullets {
    display: none;
    margin-top: -3px;

    ${breakpoints.up('md')} {
      display: flex;
    }
  }

  .swiper-pagination-bullet {
    background-color: ${WHITE};
    opacity: 0.25;
    margin: 0 8px;
    width: 8px;
    height: 8px;

    &.swiper-pagination-bullet-active {
      opacity: 1;
      transform: scale(1.5);
    }
  }
`;

export default Container;
